// Mime type send back by global storage for .woff & .ttf files
export const FONT_FILE_MIME_TYPES = {
  WOFF: 'application/font-woff',
  TTF: 'font/ttf',
};
